import { render } from "./LessonCard.vue?vue&type=template&id=b2420668&scoped=true"
import script from "./LessonCard.vue?vue&type=script&lang=js"
export * from "./LessonCard.vue?vue&type=script&lang=js"

import "./LessonCard.vue?vue&type=style&index=0&id=b2420668&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2420668"]])

export default __exports__